import Vue from 'vue';
import { client } from '@/store';

export default {
	namespaced: true,

	state: {
		agents: [],
		planners: [],
	},

	// sync actions
	mutations: {
		setAgents(state, data) {
			state.agents = data;
		},

		setPlanners(state, data) {
			state.planners = data;
		},
	},

	// async actions
	actions: {
		fetchPlanners({ commit, state, dispatch }, data) {
			const query = `
			query  {
				planners {
					id
					display_name
					username
					employee {
						id
						firstname
						infix
						lastname
					}
					tag_id: gripp_tag_id
				}
			}`;

			return new Promise((resolve, reject) => {
				commit('setLoading', null, { root: true });
				client.query(query, { ...data }).then(result => {
					commit('setIdle', null, { root: true });
					commit('setPlanners', result.planners);
					resolve(result.planners);
				});
			});
		},

		fetchAgents({ commit, state, dispatch }, data) {
			const query = `
			query  {
				agents {
					id
					display_name
					employee {
						id
						firstname
						infix
						lastname
					}
					gripp_employee_id
					google_calendar_id
					tag_id: gripp_tag_id
				}
			}`;

			return new Promise((resolve, reject) => {
				commit('setLoading', null, { root: true });
				client.query(query, { ...data }).then(result => {
					commit('setIdle', null, { root: true });
					commit('setAgents', result.agents);
					resolve(result.agents);
				});
			});
		},
	}
};
